module.exports = __webpack_public_path__ + "static/media/IMG_1240.6735384a.jpg";